<template>
  <div class="pd-content">
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/product">{{ $t('title.productCenter') }}</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-if="$store.state.langStates == 'zh'">{{ p_details.category }} {{ p_details.series
          }}</a-breadcrumb-item>
        <a-breadcrumb-item v-else>{{ p_details.category_en }} {{ p_details.series_en }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <!-- 表单 -->
    <div class="table">
      <!-- 左侧图片显示 -->
      <div class="left">
        <div class="big">

          <img
            @click="visible = true; imgUrl = 'http://' + [$store.state.langStates == 'zh' ? p_details.image_head_file : p_details.image_head_file_en]"
            :src="'http://' + [$store.state.langStates == 'zh' ? p_details.image_head_file : p_details.image_head_file_en]">
        </div>
        <div class="small text-center">
          <div v-for="(item, i) in image_file" v-show="i < 3" :key="i" class="img">
            <img @click="visible = true; imgUrl = 'http://' + item" :src="'http://' + item">
          </div>
        </div>
      </div>
      <!-- 右侧相关信息显示 -->
      <div class="right">
        <div class="main-font16 main-flex main-flex-center">
          <span class="main-font20 font-bold margin-r-20" style="width: 110px;">{{ $t('title.cpxl') }}</span>
          <span>{{ p_details.series }}{{ p_details.series_en }}</span>
        </div>
        <!-- 选择型号 -->
        <div style="margin-top: 30px;height: 50px;" class="type main-flex main-flex-center">
          <div class="main-font20 font-bold margin-r-20" style="width: 110px;">{{ $t('title.model') }}</div>
          <a-select :placeholder="$t('title.xzxh')" style="width: 580px;color: #1F5EA5;" size="large"
            @change="handleChange">
            <a-select-option v-for="(item, i) in specifications" :key="i" :value="i">
              {{ item.models }}
              {{ item.models_en }}
            </a-select-option>
          </a-select>
        </div>
        <!-- 型号详情 -->
        <div class="main-flex" style="margin: 30px 0;">
          <span class="main-font20 font-bold margin-r-20" style="width: 110px;">{{ $t('title.xhsm') }}</span>
          <div class="text_detail">
            {{ s_details.model_description }}
            {{ s_details.model_description_en }}
          </div>
        </div>
        <!-- 单价 -->
        <!-- <div class="font-bold main-flex main-flex-center" style="height: 45px;margin: 30px 0;">
          <span class="main-font20 margin-r-20" style="width: 110px;">{{ $t('title.price') }}</span><span class="main-font-color main-font30">￥{{ unit_price }}</span>
        </div> -->
        <!-- 采购数量 -->
        <div class="main-font20 margin-b-20"> <span class="margin-r-20 font-bold"
            style="width: 110px; display: inline-block;">{{ $t('title.cgsl') }}</span>
          <a-input-number id="inputNumber" v-model="value" :min="1" :max="parseInt(s_details.product_quantity)"
            @change="onChange" />
          <span class="margin-l-20 main-font16">件</span>
        </div>
        <!-- 总共价格 -->
        <!-- <div class="main-flex main-flex-center" style="height: 45px;margin: 30px 0;">
          <span v-if="value>=s_details.discount_quantity" class="main-font16 font-bold margin-r-20" style="color: #999;">{{ s_details.discount }}折</span>
          <span class="main-font20 margin-r-20 font-bold">{{ $t('title.xj') }}</span>
          <span v-if="value>=s_details.discount_quantity" style="color: #999;margin-right: 10px;" class="main-font20 text-decoration">￥{{ value * s_details.unit_price | numFilter }}</span>
          <span class="main-font-color main-font30 font-bold">￥{{ price | numFilter }}</span>
        </div> -->
        <!-- 按钮 -->
        <div class="btn" style="overflow: hidden;">
          <div>
            <a-button type="primary" :block="true" @click="ShowGoPay">{{ $t('title.ljcg') }}</a-button>
          </div>
          <div>
            <a-button type="primary" :block="true" @click="addCar(s_details.id)">{{ $t('title.addcars') }}</a-button>
          </div>
        </div>
        <div class="btn" style="overflow: hidden;margin-top: 30px;">
          <div>
            <a v-if="$store.state.langStates == 'zh'" :href="'http://' + p_details.view_file.val"
              @click.prevent="downloadItem(p_details.view_file.val, '3d')"> <a-button type="primary"
                :block="true">3D数模</a-button> </a>
            <a v-else :href="'http://' + p_details.view_file_en.val"
              @click.prevent="downloadItem(p_details.view_file_en.val, '3d')"> <a-button type="primary" :block="true">3d
                digital model</a-button> </a>
          </div>
          <div>
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item v-for="(item, i) in document_file" :key="i">
                  <a :href="'http://' + item[1].val" @click.prevent="downloadItem(item[1].val)">{{ item[0].name }}</a>
                </a-menu-item>
              </a-menu>
              <a-button type="primary" :block="true" style="position: relative;">{{ $t('title.zlxz') }}<a-icon
                  type="down" style="position: absolute;right: 10px;font-size: 20px;line-height: 35px;" /> </a-button>
            </a-dropdown>
          </div>
        </div>
      </div>
      <div class="clear" />
    </div>
    <!-- 详情 -->
    <div class="details main-center">
      <img v-if="$store.state.langStates == 'zh'" :src="'http://' + p_details.graphic_details_file.val">
      <img v-else :src="'http://' + p_details.graphic_details_file_en.val">
    </div>
    <a-modal v-model="visible" :closable="true" :footer="null" width="80%" :destroyOnClose="true" wrapClassName="video">
      <img style="width:100%" :src="imgUrl" />
    </a-modal>
    <!-- 结算弹窗 -->
    <a-modal v-model="pay" :closable="true" :footer="null" width="640px" :destroy-on-close="true"
      wrap-class-name="register">
      <div class="r_info">
        <div class="title main-font30 text-center">{{ $t('member.js') }}</div>
        <div class="info">
          <a-form :form="form" label-align="left" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" @submit="GoPay">
            <a-form-item :label="$t('member.shdz')">
              <a-select v-decorator="['shipping', { rules: [{ required: true, message: $t('tips.a4') }] },]"
                :placeholder="$t('tips.a4')">
                <a-select-option v-for="(item, i) in address" :key="i" :value="i">
                  {{ item.country }}{{ item.province }}{{ item.city }}{{ item.district }}{{ item.address }}
                </a-select-option>
                <div slot="dropdownRender" slot-scope="menu">
                  <v-nodes :vnodes="menu" />
                  <a-divider style="margin: 4px 0;" />
                  <div style="padding: 4px 8px; cursor: pointer;" @mousedown="e => e.preventDefault()" @click="addItem">
                    <a-icon type="plus" /> {{ $t('member.tjdz') }}
                  </div>
                </div>
              </a-select>
            </a-form-item>
            <a-form-item>
              <span class="ant-form-text" style="font-weight: bold;"> {{ $t('title.kp') }} </span>
            </a-form-item>
            <a-form-item :label="$t('member.qymc')">
              <a-input
                v-decorator="['company', { initialValue: member.company }, { rules: [{ required: true, message: $t('tips.s1') }] },]"
                :placeholder="$t('tips.s1')" />
            </a-form-item>
            <a-form-item :label="$t('member.ns')">
              <a-input v-decorator="['taxpayer', { rules: [{ required: true, message: $t('tips.s2') }] },]"
                :placeholder="$t('tips.s2')" />
            </a-form-item>
            <a-form-item :label="$t('member.qydz')">
              <a-input v-decorator="['address', { rules: [{ required: true, message: $t('tips.s3') }] },]"
                :placeholder="$t('tips.s3')" />
            </a-form-item>
            <a-form-item :label="$t('title.phone')">
              <a-input
                v-decorator="['phone', { initialValue: member.phone }, { rules: [{ required: true, message: $t('tips.r4') }] },]"
                :placeholder="$t('tips.r4')" />
            </a-form-item>
            <a-form-item :label="$t('member.khyh')">
              <a-input v-decorator="['bank', { rules: [{ required: true, message: $t('tips.s4') }] },]"
                :placeholder="$t('tips.s4')" />
            </a-form-item>
            <a-form-item :label="$t('member.yhkh')">
              <a-input v-decorator="['account', { rules: [{ required: true, message: $t('tips.s5') }] },]"
                :placeholder="$t('tips.s5')" />
            </a-form-item>
            <a-form-item>
              <div class="r_btn" style="width: 514px;padding-top: 10px;">
                <a-button type="primary" html-type="submit" shape="round" block> {{ $t('member.confirm') }} </a-button>
              </div>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  filters: {
    numFilter(value) {
      let realVal = ''
      if (!isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2)
      } else {
        realVal = '--'
      }
      return realVal
    }
  },
  data() {
    return {
      value: 1,
      p_details: '',
      specifications: '',
      introduction: '',
      image_file: [],
      unit_price: '--',
      price: 0,
      pay: false,
      visible: false,
      imgUrl: '',
      form: this.$form.createForm(this, {
        name: 'dynamic_rule'
      }),
      address: '',
      num: 1,
      sel: null,
      s_details: '',
      document_file: [],
      member: {
        company: '',
        phone: ''
      },
    };
  },
  watch: {
    '$route': {
      handler(route) {
        const that = this
        if (route.name === '/pDetails') {
          that.init(that.$route.query.uuid, that.$store.state.langStates)
        }
      }
    },
    '$store.state.langStates': function (val) {
      this.init(this.$route.query.uuid, val)
    }
  },
  created() {
    this.init(this.$route.query.uuid, this.$store.state.langStates)
  },
  methods: {
    // 进入页面获取
    init(id, lang) {
      this.document_file = []
      this.$api.dongjuapi.productDetails(id, lang).then(res => {
        this.p_details = res.data.data
        let tempFile = []

        // if(this.$store.state.langStates == 'zh'){
        //   tempFile = res.data.data.document_file
        // }else{
        //   tempFile = res.data.data.document_file
        // }

        console.log('--document_file--', this.document_file)
        this.specifications = res.data.data.specifications
        console.log('--specifications--', this.specifications);

        if (this.$store.state.langStates == 'zh') {
          this.image_file = res.data.data.image_file
          tempFile = res.data.data.document_file
        } else {
          this.image_file = res.data.data.image_file_en
          tempFile = res.data.data.document_file_en
        }
        tempFile.forEach(it => {
          this.document_file.push(JSON.parse(it))
        })
        console.log('型号的数据',this.sel);
        
        // 更新 型号的数据
        if (this.sel ||this.sel == 0) {
          this.s_details = this.specifications[this.sel]
          this.price = this.specifications[this.sel].unit_price
          this.unit_price = this.specifications[this.sel].unit_price
        }
      })
    },
    handleChange(value) {
      // console.log(`selected ${value}`);
      // console.log('--handleChange--',this.specifications);
      // this.init(this.$route.query.uuid, this.$store.state.langStates)
      this.sel = value
      this.s_details = this.specifications[value]
      this.price = this.specifications[value].unit_price
      this.unit_price = this.specifications[value].unit_price
    },
    // 采购数量选择
    onChange(value) {
      this.num = value
      if (value < this.s_details.discount_quantity) {
        this.price = value * this.s_details.unit_price
      } else {
        this.price = value * this.s_details.unit_price * (this.s_details.discount / 10)
      }
    },
    // 加入购物车
    addCar(id) {
      const token = this.$store.state.token
      if (token == '') {
        this.$message.error('未登录，请先登录')
      } else {
        this.$api.dongjuapi.cart({
          amount: this.value,
          specification_id: id
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('已加入购物车')
          }
        }).catch(err => {

        })
      }
    },
    // 下载
    downloadItem(url, val) {
      const token = this.$store.state.token
      var d_url = 'http://' + url
      if (val == '3d') {
        if (token == '' || token == null) {
          this.$message.error('未登录，请先登录')
          return
        }
      }
      console.log(d_url)
      window.open(d_url)
      // axios.get(d_url).then((res) => {
      // }).catch(err => {
      //   this.$message.error('链接已失效，请联系工作人员')
      // })
    },
    // 立即购买弹窗
    ShowGoPay() {
      const token = this.$store.state.token
      if (token == '') {
        this.$message.error('未登录，请先登录')
      } else if (!this.s_details) {
        this.$message.error('请选择商品规格')
      } else {
        // 收货地址
        this.$api.dongjuapi.addressList().then(res => {
          this.address = res.data.data
          this.pay = true
        }).catch(err => {
          this.$message.error(err.data.message);
        })
        // 用户信息
        this.$api.dongjuapi.member().then(res => {
          this.member = res.data.data
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 立即购买
    GoPay(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.info('success', values);
          const address_id = this.address[values.shipping].id
          const items = [{
            specification_id: this.s_details.id,
            amount: this.num
          }]
          const invoice = {
            company: values.company,
            taxpayer: values.taxpayer,
            address: values.address,
            phone: values.phone,
            bank: values.bank,
            account: values.account
          }
          const params = {
            address_id: address_id,
            items,
            invoice
          }
          this.$api.dongjuapi.get_order(params).then(res => {
            if (res.data.code == 200) {
              this.$router.push({
                path: '/settlement?no=' + res.data.data.no + '&price=' + res.data.data.total_amount
              })
            }
          })
        }
      });
    },
    // 添加地址
    addItem() {
      this.$router.push({
        path: '/address'
      })
    }
  }
};
</script>

<style lang="less">
.line {
  width: 5px;
  height: 2px;
  background: #101010;
  margin: 0 5px;
}

.pd-content {
  margin-top: 160px;

  .breadcrumb {
    height: 80px;
    line-height: 80px;
    background: #fff;
    padding: 25px 0;
    padding-left: 160px;

    .ant-breadcrumb {
      font-size: 20px;
    }
  }

  .table {
    width: 100%;
    height: auto;
    background: #fff;
    padding-bottom: 80px;
    /* padding-top: 80px; */

    .left {
      width: 810px;
      height: auto;
      padding: 0px 50px 0 160px;
      float: left;

      .big {
        width: 600px;
        height: 400px;

        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }

      .small {
        width: 600px;
        height: 127px;
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .img {
          width: 190px;
          height: 127px;
          border: 1px solid rgba(187, 187, 187, 1);

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .right {
      float: left;

      .info {
        display: flex;
        align-items: center;
        margin: 20px 0;

        .box {
          min-width: 120px;
          height: 35px;
          margin-right: 20px;
          line-height: 35px;
          border: 1px solid #bbb;
          padding: 0 10px;
        }
      }

      .list {
        width: 595px;
        height: auto;

        .list_info {
          width: 100%;
          height: auto;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          padding-left: 12px;
          flex-wrap: wrap;

          .list_item {
            width: auto;
            text-align: center;
          }

          .list_line {
            width: 5px;
            height: 2px;
            background: #101010;
            margin: 0 5px;
          }

          .list_icon {
            font-size: 0;
          }
        }

        .active {
          border: 1px solid #1F5EA5;
          position: relative;

          .list_icon {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 0;
            height: 0;
            border-bottom: 20px solid #1F5EA5;
            border-left: 20px solid transparent;
            color: #fff;

            .anticon {
              width: 10px;
              height: 10px;
              font-size: 12px;
              position: absolute;
              top: 9px;
              right: 2px;
            }
          }
        }
      }

      .btn {
        div {
          width: 200px;
          height: 50px;
          float: left;
          margin-right: 30px;
        }

        .ant-btn {
          height: 50px;
          font-size: 20px;
        }
      }
    }
  }

  .all {
    width: 100%;
    color: #1F5EA5;
  }

  .details {
    padding: 80px 0;

    img {
      width: 100%;
      height: auto;
    }
  }

  .download {
    width: 100%;
    height: 305px;
    background: #fff;

    >.main-font30 {
      padding: 70px 0 60px 0;
    }

    .btn {
      width: 660px;
      margin: 0 auto;
      overflow: hidden;

      div {
        width: 200px;
        height: 50px;
        float: left;
        margin-right: 30px;
      }

      .ant-btn {
        height: 50px;
        font-size: 16px;
      }
    }
  }
}

.type {
  .ant-select-selection--single {
    height: 50px;
    background: #F9F9F9;
    border-radius: 5px;
  }

  .ant-select-selection__rendered {
    line-height: 48px;
  }

  >.t {
    display: inline-block;
    text-align: justify;
    text-align-last: justify;
  }
}

.text_detail {
  width: 580px;
  height: 120px;
  line-height: 20px;
  text-align: left;
  border: 1px solid rgba(187, 187, 187, 100);
  padding: 10px;
  color: #101010;
  overflow-y: auto;
}
</style>
